import { render, staticRenderFns } from "./chatgroups.vue?vue&type=template&id=1131124d&scoped=true&"
import script from "./chatgroups.vue?vue&type=script&lang=js&"
export * from "./chatgroups.vue?vue&type=script&lang=js&"
import style0 from "./chatgroups.vue?vue&type=style&index=0&id=1131124d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131124d",
  null
  
)

export default component.exports